import { useCallback, useRef, useState } from 'react'
import { Box } from '@mui/material'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitleConfirm } from '$common/app-bar/app-bar-back-title-confirm'
import { Label } from '$common/label'
import { PhoneInput, PhoneInputRef } from '$common/input'
import { closeInviteViaPhone } from '$logic/router'
import { showInviteConfirmModal } from '$comp/modals/confirmation-dialog'
import { isPhoneValidByLib } from '$func/phone'
import { t } from '$i18n'

export function InviteViaPhone() {
  const [phone, setPhone] = useState('')
  const [alertText, setAlertText] = useState('')
  const phoneInputRef = useRef<PhoneInputRef>(null)

  const onSubmit = useCallback(async () => {
    if (!phoneInputRef.current) return
    if (!phone) {
      setAlertText(t('phoneInput.errorMessage'))
    }

    const fullNumber = phoneInputRef.current.getPhone(phone)

    if (isPhoneValidByLib(fullNumber)) {
      await showInviteConfirmModal([fullNumber], closeInviteViaPhone)
      setAlertText('')
    } else {
      setAlertText(t('signin.serverCodes.INVALID_PHONE'))
    }
  }, [phone])

  const onPhoneChange = useCallback((phoneNumber: string) => {
    setAlertText('')
    setPhone(phoneNumber)
  }, [])

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitleConfirm
          onBack={closeInviteViaPhone}
          onConfirm={onSubmit}
          title={t('invite.inviteViaPhone')}
        />
      }
    >
      <Box
        sx={{
          p: '20px 20px 0',
          backgroundColor: 'white',
          boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.05)',
          height: '141px',
          boxSizing: 'border-box',
        }}
      >
        <Label title={t('user.phone')} />
        <PhoneInput
          value={phone}
          onChange={onPhoneChange}
          errorMessage={alertText}
          hasError={!!alertText}
          ref={phoneInputRef}
        />
      </Box>
    </PageWithAppBar>
  )
}
